export const isEmpty = value => {
  if (!value || !value.trim()) return true;
};
